import { AlertCircle, RefreshCw } from '../../icons';
import * as React from 'react';
import { Button } from '../ui/button';

interface QueryErrorStateProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export function QueryErrorState({
  message,
  onRetry,
  className,
}: QueryErrorStateProps): React.ReactElement {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-16 ${className ?? ''}`}
    >
      <AlertCircle size={36} className="text-red-200" />
      <p className="text-body-sm-semibold text-muted-foreground">
        {message ?? 'Something went wrong'}
      </p>
      {onRetry && (
        <Button
          type="button"
          variant="outline"
          onClick={onRetry}
          className="rounded-full px-3 py-1.5 text-caption-medium h-auto"
        >
          <RefreshCw size={12} /> Try again
        </Button>
      )}
    </div>
  );
}
